import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import LogBgActions from "../../../../reducers/modules/accounting/log-bg/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "accounting/log-bg";

export default class LogBgMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(LogBgActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(LogBgActions.update());
      LogBgMiddleware.showOne(dispatch, params);
    };
  }

  static dataBGIn(params) {
    return (dispatch) => {
      dispatch(LogBgActions.process());
      LogBgMiddleware.showDataBGIn(dispatch, params);
    };
  }

  static rejectIn(params) {
    return (dispatch) => {
      dispatch(LogBgActions.process());
      LogBgMiddleware.rejectDataBGIn(dispatch, params);
    };
  }

  static dataBGOut(params) {
    return (dispatch) => {
      dispatch(LogBgActions.process());
      LogBgMiddleware.showDataBGOut(dispatch, params);
    };
  }

  static rejectOut(params) {
    return (dispatch) => {
      dispatch(LogBgActions.process());
      LogBgMiddleware.rejectDataBGOut(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(LogBgActions.process());
      LogBgMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(LogBgActions.reset());
    };
  }
  static resetIn() {
    return (dispatch) => {
      dispatch(LogBgActions.reset());
    };
  }
  static resetOut() {
    return (dispatch) => {
      dispatch(LogBgActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(LogBgActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(LogBgActions.view());
      LogBgMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(LogBgActions.submit());
      LogBgMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeReject(post, search) {
    return (dispatch) => {
      dispatch(LogBgActions.submit());
      LogBgMiddleware.reject(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(LogBgActions.submit());
      LogBgMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(LogBgActions.delete());
      LogBgMiddleware.delete(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      LogBgMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull() {
    return (dispatch) => {
      LogBgMiddleware.showHelperFull(dispatch);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(LogBgActions.list(response.data.result));
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelperFull(dispatch) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-LogBg-full",
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(LogBgActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-store",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(LogBgActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }
  static showDataBGIn(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url + "/" +params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(LogBgActions.viewDataIn(response.data.result));
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }

  static rejectDataBGIn(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url + "/reject/" +params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(LogBgActions.rejectDataIn(response.data.result));
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataBGOut(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url + "/" +params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(LogBgActions.viewDataOut(response.data.result));
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }

  static rejectDataBGOut(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url + "/reject/" +params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(LogBgActions.rejectDataOut(response.data.result));
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            LogBgActions.process(),
            LogBgMiddleware.showlist(dispatch, params)
          );
          LogBgMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            LogBgActions.process(),
            LogBgMiddleware.showlist(dispatch, search)
          );
          dispatch(LogBgActions.success());
          LogBgMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Confirm Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }

  static reject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url + '/reject',
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            LogBgActions.process(),
            LogBgMiddleware.showlist(dispatch, search)
          );
          dispatch(LogBgActions.success());
          LogBgMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Confirm Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${LogBgMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            LogBgActions.process(),
            LogBgMiddleware.showlist(dispatch, search)
          );
          dispatch(LogBgActions.success());
          LogBgMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        LogBgMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(LogBgActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(LogBgActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
